
export function orderCaculation(orderCalculationState) {
  let orderState = { ...orderCalculationState };
  let total = 0;
  let sub_total = 0;
  let flower_total_amount = 0;
  let total_commission_amount = 0;
  let tax = 0;
  let total_qty = 0;
  let upcharge_amount =
    orderState?.order_type_identifier === 1
      ? 0
      : orderState.order.upcharge_amount ?? 0;
  let discount_price = orderState.order.discount_price ?? 0;
  let discount_percentage = orderState.order.discount_percentage ?? 0;
  let delivery_charges =
    orderState?.order_type_identifier === 1
      ? 0
      : orderState.order.delivery_charges ?? 0;
  let add_fund = orderState.order.add_fund ?? 0;
  let refund = orderState.order.refund ?? 0;
  let mainTotal = orderState.order.mainTotal ?? 0;
  let subscription_discount =
    orderState.order_transaction.subscription_discount ?? 0 ?? 0;
  //   Calculate Sub total,Flowe total,total commition ,total qty calculation
  orderState.recipents.forEach((recipentData) => {
    recipentData.added_product.forEach((productData) => {
      flower_total_amount = productData.total_price + flower_total_amount;
      sub_total = productData.total_price + sub_total;
      total_commission_amount =
        productData.selectedVariant.commission * productData.qty +
        total_commission_amount;
      total_qty = total_qty + productData.qty;
    });
    recipentData.addedAddons.forEach((addonData) => {
      flower_total_amount = addonData.total_price + flower_total_amount;
      sub_total = addonData.total_price + sub_total;
      total_commission_amount =
        addonData.selectedVariant.commission * addonData.qty +
        total_commission_amount;
      total_qty = total_qty + addonData.qty;
    });
  });
  discount_price =
    discount_percentage === 0
      ? discount_price
      : (sub_total * discount_percentage) / 100;
  //   Tax calcullation
  tax =
    orderState.order.tax_id === ""
      ? ((sub_total - discount_price - subscription_discount) / 100) * 9.5
      : 0;
  total =
    tax +
    sub_total +
    delivery_charges +
    upcharge_amount -
    discount_price -
    subscription_discount;
  if (mainTotal > total) {
    let newrefund = mainTotal - total;
    refund = newrefund;
    add_fund = 0;
  } else if (mainTotal === total) {
    add_fund = 0;
    refund = 0;
  } else {
    let newAddfund = total - mainTotal;
    add_fund = newAddfund;
    refund = 0;
  }
  return {
    ...orderState,
    order: {
      ...orderState.order,
      total,
      discount_price,
      delivery_charges,
      upcharge_amount,
      total_qty,
      tax,
      total_commission_amount,
      flower_total_amount,
      sub_total,
      add_fund: add_fund.toFixed(2),
      refund: refund.toFixed(2),
    },
    order_transaction: {
      ...orderState.order_transaction,
      total,
      discount_price,
      delivery_charges,
      upcharge_amount,
      total_qty,
      tax,
      total_commission_amount,
      flower_total_amount,
      sub_total,
    },
  };
}

// Exclude notes and card text: only inputs that can change the taxable sale belong here.
export const orderTaxSignature = (values) => JSON.stringify([
  values.recipients.map((r) => [...r.products, ...r.addons].map((p) => [p.sql_id, p.id, p.selectedVariant.id, p.qty, p.total_price])),
  ...['storeId', 'order_type', 'delivery_type', 'delivery_type_id', 'zipcode', 'address_line_1', 'address_line_2', 'city', 'state', 'country', 'charge', 'upcharge_amount'].map((key) => values.delivery_information[key]),
  ...['discount_price', 'discount_percentage', 'replacement_discount_amount', 'replacement_discount_percentage'].map((key) => values.discount[key]),
  values.subscription_discount, values.petal_reward?.petal_rewards_point_amount, values.folio_bonus_discount, values.tax_id, values.payment_type, values.order_type_identifier,
]);

export function calcuateSummary(formik, applyFolio = true) {
  let total = 0;
  let sub_total = 0;
  let flower_total_amount = 0;
  let total_commission_amount = 0;
  let tax = 0;
  let total_qty = 0;
  let bonus_point_amount =
    formik.values?.petal_reward?.petal_rewards_point_amount || 0;
  let upcharge_amount =
    formik.values?.order_type_identifier === 1
      ? 0
      : formik.values.delivery_information.upcharge_amount;
  let discount_price = formik.values.discount.discount_price ?? 0;
  let discount_percentage = formik.values.discount.discount_percentage ?? 0;
  let replacement_discount_amount = formik.values.discount.replacement_discount_amount ?? 0;
  let replacement_discount_percentage = formik.values.discount.replacement_discount_percentage ?? 0;
  let delivery_charges =
    formik.values?.order_type_identifier === 1
      ? 0
      : formik.values.delivery_information.charge ? formik.values.delivery_information.charge : 0;
  let add_fund = formik.values.add_fund;
  let refund = formik.values.refund ?? 0;
  let mainTotal = formik.values.mainTotal ?? 0;
  let subscription_discount = formik.values.subscription_discount;

  formik?.values?.recipients?.forEach((recipentData) => {
    recipentData?.products?.forEach((productData) => {
      flower_total_amount = productData.total_price + flower_total_amount;
      sub_total = productData.total_price + sub_total;
      total_commission_amount =
        productData.selectedVariant.commission * productData.qty +
        total_commission_amount;
      total_qty = total_qty + productData.qty;
    });
    recipentData?.addons?.forEach((addonData) => {
      flower_total_amount = addonData.total_price + flower_total_amount;
      sub_total = addonData.total_price + sub_total;
      total_commission_amount =
        addonData.selectedVariant.commission * addonData.qty +
        total_commission_amount;
      total_qty = total_qty + addonData.qty;
    });
  });
  discount_price =
    discount_percentage === 0
      ? discount_price
      : (sub_total * discount_percentage) / 100;
  replacement_discount_amount =
    replacement_discount_percentage === 0
      ? replacement_discount_amount
      : (sub_total * replacement_discount_percentage) / 100;
  //   Tax calcullation
  discount_price = typeof discount_price === 'string' ?   parseFloat(parseFloat(discount_price).toFixed(2)) :  parseFloat(discount_price?.toFixed(2));
  tax =
    formik.values.tax_id === ""
      ? formik.values.tax_amount
      : 0;
  sub_total = Number(sub_total.toFixed(2));
  const merchandise = Math.max(0, sub_total - discount_price - replacement_discount_amount - subscription_discount - bonus_point_amount);
  const bonus = Number(formik.values.folio_bonus_discount) || 0;
  // A fully discounted sale cannot retain a merchandise bonus or negative tax.
  const returnAllBonus = merchandise === 0 && bonus > 0;
  tax = Math.max(0, tax);
  total = tax + merchandise + delivery_charges + upcharge_amount - (returnAllBonus ? 0 : bonus);
  total = Number(total.toFixed(2));
  let folio_edit_amount = 0;
  let folio_edit_bonus = returnAllBonus ? -bonus : 0;
  let folio_funded = 0;
  const increase = +(total - mainTotal).toFixed(2);
  const bonusTaxRate = formik.values.tax_id === "" ? formik.values.folio_tax_rate || 0 : 0;
  // Tax is estimated before this edit's bonus change, matching the storefront's Folio calculation.
  if (applyFolio && formik.values.folio_balance > 0 && increase > 0) {
    const ratio = formik.values.folio_bonus_balance / formik.values.folio_balance;
    const fullDraw = +(increase / (1 + ratio * bonusTaxRate)).toFixed(2);
    folio_edit_amount = Math.min(formik.values.folio_balance, fullDraw);
    folio_edit_bonus = Math.round(folio_edit_amount * ratio * 100) / 100;
    folio_funded = +(folio_edit_amount - folio_edit_bonus).toFixed(2);
    const beforeTax = total - tax - folio_edit_bonus;
    tax = folio_edit_amount === fullDraw ? +(mainTotal + folio_funded - beforeTax).toFixed(2)
      : +(tax - folio_edit_bonus * bonusTaxRate).toFixed(2);
    total = +(beforeTax + tax).toFixed(2);
  } else if (applyFolio && !returnAllBonus && formik.values.folio_bonus_remaining > 0 && formik.values.total_refund_pending > 0 && increase < 0) {
    // The refund returns this bonus share to the wallet (api splitFolioRefund checks it to the cent); the order keeps the rest.
    const share = formik.values.folio_bonus_remaining / formik.values.total_refund_pending;
    folio_edit_bonus = +(share * increase / (1 + share * (1 + bonusTaxRate))).toFixed(2);
    const beforeTax = total - tax - folio_edit_bonus;
    tax = +(tax - folio_edit_bonus * bonusTaxRate).toFixed(2);
    total = +(beforeTax + tax).toFixed(2);
  }
  refund = Math.max(0, mainTotal - total);
  add_fund = Math.max(0, total - mainTotal - folio_funded);

  return {
    total,
    discount_price,
    delivery_charges,
    replacement_discount_amount,
    upcharge_amount,
    total_qty,
    tax,
    total_commission_amount,
    flower_total_amount:Number(flower_total_amount.toFixed(2)),
    sub_total,
    add_fund: Math.max(0, +add_fund.toFixed(2)),
    refund: +refund.toFixed(2),
    subscription_discount,
    bonus_point_amount,
    folio_bonus_discount: Math.max(0, +(bonus + folio_edit_bonus).toFixed(2)),
    folio_edit_amount,
    folio_edit_bonus,
  };
}


export const calculateKintsugiItemPrice = (summary, formik) => {
  const discount_percentage_per_item = discountParcentagePerItem(summary);
  const priced = (p) => ({ ...p, kintsugi_item_price: p.total_price - discountPricePerItem(p.total_price, discount_percentage_per_item) });
  return formik?.values?.recipients?.map((r) => ({ ...r, products: (r.products || []).map(priced), addons: (r.addons || []).map(priced) }));
};

export const discountParcentagePerItem = (summary) => {
  let discount_price = summary.discount_price + summary.bonus_point_amount + summary.replacement_discount_amount + summary.folio_bonus_discount;
  let discount_percentage_per_item = summary.sub_total > 0 ? Math.min(100, (discount_price / summary.sub_total) * 100) : 0;
  return +discount_percentage_per_item.toFixed(4);
}

export const discountPricePerItem = (amount = 0,percentage = 0) => {
  let discount_price_per_item = (amount * percentage) / 100;
  return +discount_price_per_item.toFixed(4);
}

/**
 * Calculates the tax rate as a percentage based on the subtotal and tax amount
 * @param {number} subTotal - The total amount before tax (base amount for tax calculation)
 * @param {number} taxAmount - The actual tax amount charged
 * @returns {number} The calculated tax rate as a percentage, rounded to 2 decimal places
 * Example: If subTotal is $100 and taxAmount is $9.50, returns 9.500 (%)
 */
export const calculateTaxRate = (subTotal, taxAmount) => {
  const percentage = (taxAmount / subTotal) * 100;
  return parseFloat(percentage.toFixed(3)); // Rounded to 3 decimal places
}

/**
 * Calculates tax-related information for house accounts, including per-item tax breakdown
 * @param {Array} recipients - Array of recipients, each containing products and addons
 * @param {Object} summary - Order summary containing subtotal, discount, and tax information
 * @returns {Object} Returns an object containing:
 *   - recipients: Updated recipients array with tax calculations for each item
 *   - tax_rate: Overall tax rate for the order
 *   - tax: Total tax amount
 *   - taxable_amount: Total amount subject to tax
 */
export const houseAccountTaxCalculation = (recipients, summary) => {
  try {
    // Calculate the discount percentage that applies to each item
    const discount_percentage_per_item = discountParcentagePerItem(summary);
    // Calculate the overall tax rate for the order
    const tax_rate = calculateTaxRate(summary.sub_total - summary.discount_price, summary.tax);

    const recipientsData = recipients?.map((recipient) => {
      // Process products for each recipient
      recipient.products.length > 0 &&
        recipient.products?.map((product) => {
          // Calculate tax details for each product
          const discounted_amount = discountPricePerItem(product.total_price, discount_percentage_per_item);
          const taxable_amount = product.total_price - discounted_amount;
          const taxAmount = (taxable_amount * tax_rate) / 100;
          
          // Update product with tax information
          product.tax = Number(taxAmount.toFixed(2));
          product.taxable_amount = Number(taxable_amount.toFixed(2));
          product.tax_rate = Number(tax_rate.toFixed(3));
          product.kintsugi_item_price = Number(taxable_amount.toFixed(2));
          return product;
        });

      // Process addons for each recipient
      recipient.addons.length > 0 &&
        recipient.addons?.map((addon) => {
          // Calculate tax details for each addon
          const discounted_amount = discountPricePerItem(addon.total_price, discount_percentage_per_item);
          const taxable_amount = addon.total_price - discounted_amount;
          const taxAmount = (taxable_amount * tax_rate) / 100;
          
          // Update addon with tax information
          addon.tax = Number(taxAmount.toFixed(2)); 
          addon.taxable_amount = Number(taxable_amount.toFixed(2));
          addon.tax_rate = Number(tax_rate.toFixed(3));
          addon.kintsugi_item_price = Number(taxable_amount.toFixed(2));
          return addon;
        });
      return recipient;
    });

    // Return the complete tax calculation results
    return {
      recipients: recipientsData,
      tax_rate: tax_rate,
      tax: summary.tax,
      taxable_amount: summary.sub_total - summary.discount_price,
    }
  } catch (error) {
    // Return default values if calculation fails
    return {
      recipients: [],
      tax_rate: 0,
      tax: 0,
      taxable_amount: 0,
    }
  }
};
